module.exports = __webpack_public_path__ + "img/M.33d05006.jpg";